import { setStats } from '../../actions/statsSection';

export function getStatsSectionInitActions(responseData, requestParams) {
  return [setStats(responseData.sectionData)];
}
